var map = {
	"./active-btn.webp": 2508,
	"./angbao-bonus-thaipusam.webp": 2509,
	"./angbao-bonus.webp": 2510,
	"./angbao-bonus_dewali.webp": 2511,
	"./cny-lucky-draw.webp": 2512,
	"./cny-promo.webp": 2513,
	"./dewali-promo.webp": 2514,
	"./fifa-prediction.webp": 2515,
	"./fifa-qna.webp": 2516,
	"./raya-promo.webp": 2517,
	"./welcome-cny-bonus.webp": 2518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2507;